import React from 'react'
import './headerBlock.css'

const HeaderBlock = ({className, children}) => (
  <div className={[className,'header-block'].join(' ')}>
    <div className='gridcontainer'>
      {children}
    </div>
  </div>
)
export default HeaderBlock



// WEBPACK FOOTER //
// ./src/core/components/header-block/HeaderBlock.js